import { useSelector } from "react-redux";

import { StateShape } from "../redux/store";
import { getButtonColors, getOutlineStyle, getPrimaryStyle, isDarkTheme } from "../utils/colors";

const stateSelector = (state: StateShape) => ({
    dark: isDarkTheme(state),
    configurationData: state.configuration.data,
    applicationParams: state.application.params.params,
});

export const useTheme = () => {
    const { dark } = useSelector(stateSelector);

    return dark;
};

export const useButtonStyles = (hover: boolean) => {
    const { configurationData, dark, applicationParams } = useSelector(stateSelector);

    const colors = getButtonColors(configurationData, dark, applicationParams);
    const styles = getPrimaryStyle(colors, hover);

    return styles?.button;
};

export const useButtonOutlinedStyles = (hover: boolean) => {
    const { configurationData, dark, applicationParams } = useSelector(stateSelector);

    const colors = getButtonColors(configurationData, dark, applicationParams);
    const styles = getOutlineStyle(colors, hover, dark);

    return styles?.button;
};
